import { render, staticRenderFns } from "./TypeInstrumentForm.vue?vue&type=template&id=0f1c8c74&"
import script from "./TypeInstrumentForm.vue?vue&type=script&lang=js&"
export * from "./TypeInstrumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports